import type {
	GridOptions,
	StackOptions,
	TreeOptions,
	RadialOptions,
	ForceOptions,
	Force2Options,
	GridifyOptions,
	FlowOptions,
	PackOptions,
	SortOptions,
} from './types';

export const GRID_DEFAULTS: GridOptions = {
	direction: 'row',
	count: 'auto',
	spacing: { x: 20, y: 20 },
	cellSize: 'uniform',
	align: { x: 'center', y: 'center' },
	anchor: 'minimizeMovement',
	avoidObstacles: false,
};

export const STACK_DEFAULTS: StackOptions = {
	direction: 'horizontal',
	spacing: 20,
	align: 'center',
	anchor: 'minimizeMovement',
};

export const TREE_DEFAULTS: TreeOptions = {
	direction: 'down',
	spacing: { level: 80, sibling: 40 },
	root: 'auto',
	multiParent: 'closest',
	childAlign: 'center',
};

export const RADIAL_DEFAULTS: RadialOptions = {
	center: 'auto',
	ringSpacing: 120,
	minAngle: 0.1,
	startAngle: 0,
	sweep: Math.PI * 2,
};

export const FORCE_DEFAULTS: ForceOptions = {
	repulsion: 210780,
	attraction: 0.25,
	edgeLength: 0,
	damping: 0.9,
	mode: 'converge',
	iterations: 300,
	threshold: 0.1,
	avoidObstacles: true,
	centerGravity: 0.02,
	overlapPenalty: 6.5,
	edgeCrossPenalty: 3.7,
	compactness: 0.03,
	minDistance: 10,
};

export const FORCE2_DEFAULTS: Force2Options = {
	spacing: 0.23,
	attraction: 0.055,
	degreeRepulsion: 0.5,
	temperature: 0.13,
	gravity: 0.055,
	minDistance: 10,
	mode: 'converge',
	iterations: 301,
	threshold: 1.02,
	avoidObstacles: true,
};

export const GRIDIFY_DEFAULTS: GridifyOptions = {
	gridPull: 12,
	displacement: 0.05,
	nodeOverlap: 10,
	edgeNodeOverlap: 3,
	edgeCrossing: 1,
	threshold: 40,
	iterations: 120,
	minDistance: 10,
	localRadius: 260,
	scaleGrowth: 2.7,
	gridSnap: 0.45,
	mobility: 0.3,
	growToAlign: 0,
	maxGrow: 20,
	lockedAspectRatio: [],
};

export const FLOW_DEFAULTS: FlowOptions = {
	direction: 'down',
	spacing: { rank: 80, node: 40 },
	align: 'center',
	edgeRouting: 'straight',
	minimizeCrossings: true,
};

export const PACK_DEFAULTS: PackOptions = {
	spacing: 20,
	anchor: 'minimizeMovement',
};

export const SORT_DEFAULTS: SortOptions = {
	spacing: 20,
	anchor: 'minimizeMovement',
};
